module.exports = (s) => {
  return [
    {
      name: '角色ID',
      value: 'id',
      width: 80,
    },
    {
      name: '角色名称',
      value: 'name',
    },
    {
      name: '已分配账号数',
      value: 'user_count',
      width: 120,
    },
    {
      name: '游戏权限',
      format: (row) => {
        const { id, permissions } = row;
        const games = permissions && Array.isArray(permissions.games) ? permissions.games : null;
        const h = s.$createElement;
        // 列表接口不再保证返回权限数据，取不到时占位，避免被误判为“全权限”
        if (id !== 1 && games === null) {
          return h('span', null, '-');
        }
        const game_list = games || [];
        const ele = (id === 1 || game_list.length === 0) ? h('span', null, '全权限') : h(
          'el-select',
          {
            props: {
              placeholder: '查看角色游戏权限',
              size: 'mini',
              filterable: true,
              value: null,
            },
          },
          game_list.map(({ name, id }) => {
            return h('el-option', {
              props: {
                label: `${id} ${name}`,
                value: id,
              },
            }, null);
          }));
        return ele;
      },
    },
    {
      name: '操作',
      width: 220,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            plain: true,
            disabled: row.id === 1,
          },
          on: {
            click: () => {
              s?.assignPermission(row);
            },
          },
        }, '分配权限');
        const assign_game_btn = h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            plain: true,
            disabled: row.id === 1,
          },
          on: {
            click: () => {
              s?.openAssignGamesDialog(row);
            },
          },
        }, '分配游戏权限');
        return h('div', null, [assign_game_btn, ele]);
      },
    },
  ];
};
